import { runtimeEnv } from "config/runtimeEnv";
import React, { useMemo } from 'react'
import { GoogleMap, Marker, useLoadScript } from '@react-google-maps/api'
import { Grid, Typography } from '@mui/material'
import InfoIcon from '@mui/icons-material/Info';
import PickUp from 'components/pickAndDrop/PickUp';
import WrappedMap from 'components/commonMap/CommonMap';
import whiteCar from 'assets/images/whiteCar.svg';
import driverVerified from 'assets/images/driverVerified.svg'
import checkVerified from 'assets/images/checkCircle.svg'
import greyCall from 'assets/images/greyCall.svg'
import { companyDetails } from 'utils/companyDetails';

function TripDetails() {
  const { isLoaded } = useLoadScript({
    googleMapsApiKey: runtimeEnv("GOOGLE_API_KEY"),
  });
  const center = useMemo(() => ({
    lat: 12.91626046912438, lng: 77.60570238465706
  }),
    []
  );
  const mapURL = `https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry,drawing,places&key=${runtimeEnv("GOOGLE_API_KEY")}`;  
  let flightPlanCoordinates = [
    { lat: 12.917579669617652, lng: 77.60980048242587 },
    { lat: 12.912641028963655, lng: 77.64406738203964 },
  ];

  return (
    <div>
      <Grid container md={12} sm={12} xs={12} flexDirection='row' className="mobileView">
        <Grid item md={4} sm={5} xs={12}
          className='marginAlign'>
          <Typography className='fs36Fw600' >Lakshmi Trip details</Typography>
          <PickUp />
          <hr />
          {/*TODO we need to give condition if trip details are done move to driver details */}
          <Grid item container md={12} xs={12} sm={12} flexDirection='row' justifyContent='space-evenly'
          alignItems='center'>
            {/* <Grid item md={5} xs={5} sm={5}>
              <img src={whiteCar} alt='WhiteCar' />
              <Typography className='marginLeft20'>SUV</Typography>
            </Grid>
            <Grid item md={5} xs={5} sm={5}>
              <Typography className='colorGrey font16 fontNormal'>We will assign your driver before 60min of your trip </Typography>
            </Grid> */}
            <Grid item md={5} xs={6} sm={5}>
              <img src={whiteCar} alt='WhiteCar' />
              <Typography className='font16 colorBlue'><img className=' marginBottom5' src={driverVerified} alt='vector'/> Suresh Kumar</Typography>
              <Typography className=' colorGrey font14'>Top-rated Driver</Typography>

            </Grid>
            <Grid item md={5} sm={5}>
              <Typography className='fontweight500 font16 fontNormal'>KA 04 5568 </Typography>
              <Typography className='font14'>SUV</Typography>
              <Typography className='font14'><img className=' marginBottom5' src={checkVerified} alt="checkVerified"/> Driver Vaccinated</Typography>
            </Grid>
          </Grid>
          
          <Grid item  container flexDirection='row' justifyContent='space-evenly' alignItems='center' className="marginBlock30">
            <Grid item>
            <img className='' src={greyCall} alt='greycall'/>
            </Grid>
            <Grid item>
            <Typography className=' underline'><span> <InfoIcon className=' font20 marginBottom5' /></span>  Read {companyDetails?.companyName}'s Privacy Notice</Typography>
            </Grid>
            {/* <Typography><img className='marginLeft20 marginBottom15' src={greyCall} alt='greycall'/><span> <InfoIcon className=' font20 marginBottom5' /></span>  Read ITER's Privacy Notice</Typography> */}
          </Grid>
        </Grid>
        <Grid item md={7.8} sm={6} sx={12} className='mapView'>

          {!isLoaded ? (<h1>Loading...</h1>) :
            (<WrappedMap
              paths={flightPlanCoordinates}
              stops={flightPlanCoordinates}
              googleMapURL={mapURL}
              loadingElement={<div style={{ height: `100%` }} />}
              containerElement={<div className='mapContainer'  />}
              mapElement={<div style={{ height: `100%` }} />}
        />)}
        </Grid>

      </Grid>
    </div>
  )
}

export default TripDetails
